/* DBS jukebox: floating dime -> coin drop -> music player.
 * Look: colors and background from the "Matrix" Winamp skin by sukhi batth (freeware, credited).
 * Every control is labeled. Nothing plays until the visitor clicks the dime.
 * window.DBS.jukeboxTracks = [{ title, src }]  window.DBS.skin.main = background image  window.DBS.coinDrop = sound
 */
(function () {
  'use strict';

  var D = window.DBS || {};
  var tracks = D.jukeboxTracks || [];
  if (!tracks.length || document.getElementById('dbsj')) return;

  var KEY = 'dbsj';
  var state = { open: false, playing: false, t: 0, track: 0, vol: 0.8, repeat: false, shuffle: false, pl: true, x: null, y: null };
  try { Object.assign(state, JSON.parse(sessionStorage.getItem(KEY) || '{}')); } catch (e) {}
  if (state.track >= tracks.length) state.track = 0;
  function save() { try { sessionStorage.setItem(KEY, JSON.stringify(state)); } catch (e) {} }


  var I = {
    prev:  '<svg viewBox="0 0 16 12"><rect x="1" y="1" width="2.4" height="10"/><path d="M14 1v10L5 6z"/></svg>',
    play:  '<svg viewBox="0 0 16 12"><path d="M4 1v10l9-5z"/></svg>',
    pause: '<svg viewBox="0 0 16 12"><rect x="3.5" y="1" width="3.4" height="10"/><rect x="9.2" y="1" width="3.4" height="10"/></svg>',
    stop:  '<svg viewBox="0 0 16 12"><rect x="3.5" y="1" width="9" height="10"/></svg>',
    next:  '<svg viewBox="0 0 16 12"><path d="M2 1v10l9-5z"/><rect x="12.6" y="1" width="2.4" height="10"/></svg>'
  };
  function btn(cls, icon, label) {
    return '<button type="button" class="jb-btn ' + cls + '" aria-label="' + label + '">' + I[icon] + '<span>' + label + '</span></button>';
  }

  /* ---------- DOM ---------- */
  var wrap = document.createElement('div');
  wrap.setAttribute('data-no-chaos', '');
  wrap.innerHTML =
    '<button type="button" id="dbsj-fab" class="dbsj-fab dbsx-float" aria-label="Open the jukebox" title="drop a dime">' +
      '<svg class="dbsj-coin" viewBox="0 0 64 64" aria-hidden="true">' +
        '<defs><linearGradient id="dbsj-g" x1="0" y1="0" x2="1" y2="1"><stop offset="0" stop-color="#ffffff"/><stop offset=".45" stop-color="#b9c2cc"/><stop offset="1" stop-color="#7d8793"/></linearGradient></defs>' +
        '<circle cx="32" cy="32" r="29" fill="url(#dbsj-g)" stroke="#111" stroke-width="3"/>' +
        '<circle cx="32" cy="32" r="23" fill="none" stroke="#5c6672" stroke-width="2" stroke-dasharray="2.2 2.2"/>' +
        '<path d="M27 40V20l14-4v20" fill="none" stroke="#111" stroke-width="3.2" stroke-linejoin="round" stroke-linecap="round"/>' +
        '<ellipse cx="24" cy="41" rx="4.6" ry="3.6" fill="#111"/><ellipse cx="38" cy="37" rx="4.6" ry="3.6" fill="#111"/>' +
      '</svg>' +
    '</button>' +
    '<section id="dbsj" class="dbsj" aria-label="Jukebox">' +
      '<div class="jb-title" data-drag>' +
        '<span class="jb-grip"></span><span class="jb-name">da jukeboxTM drop a dime</span><span class="jb-grip"></span>' +
        '<button type="button" class="jb-tb jb-min" aria-label="Hide (keeps playing)" title="Hide (keeps playing)">_</button>' +
        '<button type="button" class="jb-tb jb-x" aria-label="Stop and close" title="Stop and close">x</button>' +
      '</div>' +
      '<div class="jb-body">' +
        '<div class="jb-screen">' +
          '<div class="jb-row"><span class="jb-state">STOPPED</span><span class="jb-time">0:00 / 0:00</span></div>' +
          '<div class="jb-marq"><span class="jb-mtext"></span></div>' +
          '<canvas class="jb-vis" width="320" height="56"></canvas>' +
        '</div>' +
        '<label class="jb-lab jb-seekwrap"><span>SEEK</span><input class="jb-seek" type="range" min="0" max="1000" value="0"></label>' +
        '<div class="jb-ctl">' +
          btn('jb-prev', 'prev', 'PREV') + btn('jb-play', 'play', 'PLAY') + btn('jb-pause', 'pause', 'PAUSE') +
          btn('jb-stop', 'stop', 'STOP') + btn('jb-next', 'next', 'NEXT') +
        '</div>' +
        '<div class="jb-row2">' +
          '<label class="jb-lab jb-volwrap"><span>VOL</span><input class="jb-vol" type="range" min="0" max="1" step="0.01"></label>' +
          '<button type="button" class="jb-tog jb-shuf" aria-pressed="false">SHUFFLE</button>' +
          '<button type="button" class="jb-tog jb-rep" aria-pressed="false">REPEAT</button>' +
          '<button type="button" class="jb-tog jb-plb" aria-pressed="false">PLAYLIST</button>' +
        '</div>' +
        '<ol class="jb-pl"></ol>' +
      '</div>' +
      '<audio preload="none" crossorigin="anonymous"></audio>' +
    '</section>';
  document.body.appendChild(wrap);

  var $ = function (s) { return wrap.querySelector(s); };
  var fab = $('#dbsj-fab'), box = $('#dbsj'), audio = $('audio');
  var stateEl = $('.jb-state'), timeEl = $('.jb-time'), mtext = $('.jb-mtext');
  var seek = $('.jb-seek'), vol = $('.jb-vol'), list = $('.jb-pl');
  var vis = $('.jb-vis'), vg = vis.getContext('2d');
  var durations = {}, seeking = false;

  function fmt(sec) {
    if (!isFinite(sec) || sec < 0) sec = 0;
    var m = Math.floor(sec / 60), s = Math.floor(sec % 60);
    return m + ':' + (s < 10 ? '0' : '') + s;
  }
  function cur() { return tracks[state.track] || tracks[0]; }
  function isPlaying() { return !audio.paused && !audio.ended; }
  function paintRange(el) { el.style.setProperty('--p', ((el.value - el.min) / (el.max - el.min)) * 100 + '%'); }

  /* ---------- title marquee ---------- */
  var flashTimer = 0;
  function titleText() {
    var d = durations[state.track] ? '  (' + fmt(durations[state.track]) + ')' : '';
    return (state.track + 1) + '. ' + cur().title + d;
  }
  function setMarquee(text) {
    mtext.textContent = text;
    mtext.parentNode.classList.toggle('is-long', text.length > 34);
  }
  function flash(text, ms) {
    clearTimeout(flashTimer);
    setMarquee(text);
    flashTimer = setTimeout(function () { setMarquee(titleText()); }, ms || 3000);
  }

  /* ---------- playlist ---------- */
  function renderPl() {
    list.innerHTML = '';
    tracks.forEach(function (t, i) {
      var li = document.createElement('li');
      if (i === state.track) li.className = 'is-cur';
      li.title = 'Click to play';
      li.innerHTML = '<span class="n"></span><span class="t"></span><span class="d"></span>';
      li.children[0].textContent = (i + 1) + '.';
      li.children[1].textContent = t.title;
      li.children[2].textContent = durations[i] ? fmt(durations[i]) : '';
      li.addEventListener('click', function () { loadTrack(i, true); });
      list.appendChild(li);
    });
    var c = list.querySelector('.is-cur');
    if (c && state.pl && box.classList.contains('is-open')) {
      var top = c.offsetTop - list.offsetTop;
      if (top < list.scrollTop || top > list.scrollTop + list.clientHeight - 24) list.scrollTop = Math.max(0, top - 24);
    }
  }

  /* ---------- audio graph for the visualizer ---------- */
  var analyser = null, fdata = null, graphTried = false;
  function buildGraph(ctx) {
    try {
      var src = ctx.createMediaElementSource(audio);
      analyser = ctx.createAnalyser();
      analyser.fftSize = 256;
      analyser.smoothingTimeConstant = 0.72;
      src.connect(analyser);
      analyser.connect(ctx.destination);
      fdata = new Uint8Array(analyser.frequencyBinCount);
    } catch (e) { analyser = null; }
  }
  function ensureGraph() {
    if (graphTried) return;
    graphTried = true;
    try {
      var AC = window.AudioContext || window.webkitAudioContext;
      if (!AC || !audio.crossOrigin) return;
      var ctx = new AC();
      if (ctx.state === 'suspended') {
        ctx.resume().then(function () { if (ctx.state === 'running') buildGraph(ctx); else ctx.close(); }).catch(function () {});
      } else buildGraph(ctx);
    } catch (e) {}
  }

  /* ---------- transport ---------- */
  function ui() {
    var playing = isPlaying();
    var stopped = !playing && audio.currentTime < 0.05;
    // remember the real play state right away (the page stings stay quiet only while music plays)
    if (state.playing !== playing) { state.playing = playing; save(); }
    stateEl.textContent = playing ? '▶ PLAYING' : (stopped ? '■ STOPPED' : '❚❚ PAUSED');
    box.classList.toggle('is-playing', playing);
    box.classList.toggle('is-paused', !playing && !stopped);
    box.classList.toggle('pl-on', !!state.pl);
    fab.classList.toggle('is-playing', playing);
    $('.jb-play').classList.toggle('is-on', playing);
    $('.jb-pause').classList.toggle('is-on', !playing && !stopped);
    [['.jb-shuf', state.shuffle], ['.jb-rep', state.repeat], ['.jb-plb', state.pl]].forEach(function (p) {
      $(p[0]).classList.toggle('is-on', !!p[1]);
      $(p[0]).setAttribute('aria-pressed', p[1] ? 'true' : 'false');
    });
    fab.setAttribute('aria-label', box.classList.contains('is-open') ? 'Hide the jukebox' : 'Open the jukebox');
  }
  function nextIndex(dir) {
    if (state.shuffle && tracks.length > 2) {
      var n;
      do { n = (Math.random() * tracks.length) | 0; } while (n === state.track);
      return n;
    }
    return state.track + dir;
  }
  function loadTrack(i, autoplay) {
    state.track = (i + tracks.length) % tracks.length;
    state.t = 0;
    audio.src = cur().src;
    setMarquee(titleText());
    renderPl();
    if (autoplay) play();
    ui();
  }
  function play() {
    if (!audio.getAttribute('src')) audio.src = cur().src;
    var pr = audio.play();
    if (pr && pr.catch) pr.catch(function () { ui(); });
    ui();
  }
  function stop() { audio.pause(); try { audio.currentTime = 0; } catch (e) {} state.t = 0; save(); ui(); }

  function on(sel, fn) { $(sel).addEventListener('click', fn); }
  on('.jb-play', function () { if (audio.paused) play(); });
  on('.jb-pause', function () { if (audio.paused) { if (audio.currentTime > 0.05) play(); } else { audio.pause(); ui(); } });
  on('.jb-stop', stop);
  on('.jb-prev', function () { if (audio.currentTime > 3 || tracks.length < 2) audio.currentTime = 0; else loadTrack(nextIndex(-1), true); });
  on('.jb-next', function () { if (tracks.length < 2) audio.currentTime = 0; else loadTrack(nextIndex(1), true); });
  on('.jb-shuf', function () { state.shuffle = !state.shuffle; save(); ui(); flash(state.shuffle ? 'shuffle: on' : 'shuffle: off', 1500); });
  on('.jb-rep', function () { state.repeat = !state.repeat; save(); ui(); flash(state.repeat ? 'repeat: on' : 'repeat: off', 1500); });
  on('.jb-plb', function () { state.pl = !state.pl; save(); ui(); renderPl(); applyPos(); });

  vol.addEventListener('input', function () { audio.volume = +vol.value; state.vol = audio.volume; paintRange(vol); flash('volume: ' + Math.round(audio.volume * 100) + '%', 1200); });
  vol.addEventListener('change', save);
  seek.addEventListener('input', function () {
    seeking = true; paintRange(seek);
    var d = audio.duration;
    if (isFinite(d) && d > 0) timeEl.textContent = fmt((seek.value / 1000) * d) + ' / ' + fmt(d);
  });
  seek.addEventListener('change', function () {
    var d = audio.duration;
    if (isFinite(d) && d > 0) audio.currentTime = (seek.value / 1000) * d;
    seeking = false;
  });

  /* ---------- audio events ---------- */
  audio.addEventListener('playing', function () { ensureGraph(); ui(); });
  audio.addEventListener('pause', ui);
  audio.addEventListener('ended', function () {
    if (state.repeat && tracks.length < 2) { audio.currentTime = 0; play(); }
    else if (tracks.length > 1 && (state.repeat || state.shuffle || state.track < tracks.length - 1)) loadTrack(nextIndex(1), true);
    else { try { audio.currentTime = 0; } catch (e) {} ui(); }
    save();
  });
  audio.addEventListener('loadedmetadata', function () {
    durations[state.track] = audio.duration;
    setMarquee(titleText());
    renderPl();
    if (state._resumeAt) { try { audio.currentTime = state._resumeAt; } catch (e) {} state._resumeAt = 0; }
  });
  var retried = false;
  audio.addEventListener('error', function () {
    // if the music host refuses cross-origin audio, retry once without it (visualizer then fakes it)
    if (!retried && audio.crossOrigin && !analyser) {
      retried = true;
      var t = audio.currentTime;
      audio.removeAttribute('crossorigin');
      audio.src = cur().src;
      if (t) state._resumeAt = t;
      play();
      return;
    }
    flash("can't load: " + cur().title, 4000);
    ui();
  });

  var lastSave = 0;
  audio.addEventListener('timeupdate', function () {
    var d = audio.duration;
    if (!seeking) {
      timeEl.textContent = fmt(audio.currentTime) + ' / ' + fmt(d);
      seek.value = (isFinite(d) && d > 0) ? Math.round((audio.currentTime / d) * 1000) : 0;
      paintRange(seek);
    }
    var now = Date.now();
    if (now - lastSave > 900) {
      lastSave = now;
      state.playing = isPlaying();
      state.t = audio.currentTime || 0;
      save();
    }
  });

  /* ---------- visualizer: Matrix-green bars with peaks ---------- */
  var BARS = 32, levels = [], peaks = [], raf = 0;
  for (var b = 0; b < BARS; b++) { levels.push(0); peaks.push(0); }
  var grad = vg.createLinearGradient(0, 56, 0, 0);
  grad.addColorStop(0, '#0b5e2a');
  grad.addColorStop(0.55, '#3dff3d');
  grad.addColorStop(1, '#d8e7ae');
  function drawVis(ts) {
    raf = requestAnimationFrame(drawVis);
    var W = vis.width, H = vis.height, playing = isPlaying();
    vg.clearRect(0, 0, W, H);
    if (analyser && playing) analyser.getByteFrequencyData(fdata);
    var bw = W / BARS;
    for (var i = 0; i < BARS; i++) {
      var v;
      if (!playing) v = 0;
      else if (analyser) {
        var lo = Math.floor(Math.pow(i / BARS, 1.7) * fdata.length * 0.85);
        var hi = Math.max(lo + 1, Math.floor(Math.pow((i + 1) / BARS, 1.7) * fdata.length * 0.85));
        var sum = 0;
        for (var k = lo; k < hi; k++) sum += fdata[k];
        v = sum / (hi - lo) / 255;
      } else v = 0.15 + 0.7 * Math.abs(Math.sin(ts * 0.004 * (1 + i * 0.11) + i * 1.7)) * (0.55 + 0.45 * Math.random());
      levels[i] = Math.max(v, levels[i] - 0.05);
      peaks[i] = Math.max(levels[i], peaks[i] - 0.012);
      var h = Math.round(levels[i] * H);
      vg.fillStyle = grad;
      for (var y = H - h; y < H; y += 3) vg.fillRect(Math.round(i * bw) + 1, y, Math.ceil(bw) - 3, 2);
      if (peaks[i] > 0.03) {
        vg.fillStyle = '#ffffff';
        vg.fillRect(Math.round(i * bw) + 1, H - Math.round(peaks[i] * H) - 2, Math.ceil(bw) - 3, 2);
      }
    }
  }
  function startVis() { if (!raf) raf = requestAnimationFrame(drawVis); }
  function stopVis() { if (raf) { cancelAnimationFrame(raf); raf = 0; } }

  /* ---------- coin drop, open, close ---------- */
  var coin = D.coinDrop ? new Audio(D.coinDrop) : null;
  if (coin) { coin.preload = 'auto'; coin.volume = 0.9; }
  function dropDime(then) {
    if (!coin) return then();
    try { coin.currentTime = 0; } catch (e) {}
    var done = false;
    function go() { if (!done) { done = true; then(); } }
    var pr = coin.play();
    if (pr && pr.then) pr.then(function () { setTimeout(go, 750); }).catch(go);
    else setTimeout(go, 750);
  }

  function applyPos() {
    if (state.x == null || state.y == null || !box.classList.contains('is-open')) return;
    var maxX = Math.max(0, window.innerWidth - box.offsetWidth);
    var maxY = Math.max(0, window.innerHeight - 40);
    box.style.left = Math.min(Math.max(0, state.x), maxX) + 'px';
    box.style.top = Math.min(Math.max(0, state.y), maxY) + 'px';
    box.style.right = 'auto';
    box.style.bottom = 'auto';
  }
  function open() {
    box.classList.add('is-open');
    state.open = true; save();
    applyPos(); startVis();
    if (!audio.getAttribute('src')) { audio.src = cur().src; setMarquee(titleText()); renderPl(); }
    if (audio.paused && audio.currentTime < 0.05) dropDime(play);
    ui();
  }
  function hide() {
    box.classList.remove('is-open');
    state.open = false; save();
    stopVis(); ui();
  }
  fab.addEventListener('click', function () { box.classList.contains('is-open') ? hide() : open(); });
  // anything marked data-dbs-jukebox (like the Jukebox desktop icon) opens the player too
  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('[data-dbs-jukebox]');
    if (!t) return;
    e.preventDefault();
    if (!box.classList.contains('is-open')) open();
    else if (audio.paused) play();
  });
  on('.jb-min', hide);
  on('.jb-x', function () { stop(); hide(); });

  (function () {
    var bar = $('.jb-title'), drag = null;
    bar.addEventListener('pointerdown', function (e) {
      if (e.target.closest('button')) return;
      var r = box.getBoundingClientRect();
      drag = { dx: e.clientX - r.left, dy: e.clientY - r.top };
      bar.setPointerCapture(e.pointerId);
      e.preventDefault();
    });
    bar.addEventListener('pointermove', function (e) {
      if (!drag) return;
      state.x = e.clientX - drag.dx; state.y = e.clientY - drag.dy;
      applyPos();
    });
    function end() { if (drag) { drag = null; save(); } }
    bar.addEventListener('pointerup', end);
    bar.addEventListener('pointercancel', end);
    window.addEventListener('resize', applyPos);
  })();

  /* ---------- start ---------- */
  audio.volume = Math.max(0, Math.min(1, +state.vol));
  vol.value = audio.volume;
  paintRange(vol); paintRange(seek);
  setMarquee(titleText()); renderPl(); ui();
  if (state.open) {
    box.classList.add('is-open');
    audio.src = cur().src;
    startVis();
    if (state.t) state._resumeAt = state.t;
    if (state.playing) play();
    applyPos(); ui();
  }
})();
